import markItemsJunkNotJunkBasedOnItemIds from './markItemsJunkNotJunkBasedOnItemIds';
import createItemContextsForDeleteStoreUpdate from '../../helpers/createItemContextsForDeleteStoreUpdate';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
/**
 * The action which marks items as junk.
 * @param itemRowKeys - the rows to mark as junk
 * @param tableView - the table view the items are from
 * @param isJunkValueToSet - whether it is a mark as junk or not junk action
 * @param actionSource - where the action is triggered from
 */
export default function markItemsJunkNotJunkFromTable(itemRowKeys, tableView, isJunkValueToSet, actionSource) {
    var itemIdStrings = getRowIdsFromRowKeys(itemRowKeys, tableView.id);
    var instrumentationContexts = getInstrumentationContextsFromTableView(itemRowKeys, tableView);
    markItemsJunkNotJunkBasedOnItemIds(itemIdStrings, isJunkValueToSet, actionSource, instrumentationContexts, function () {
        var itemContexts = createItemContextsForDeleteStoreUpdate(itemIdStrings);
        // Dispatch action to update the store state
        deleteItemsStoreUpdate(itemContexts, tableView.tableQuery.folderId);
    });
}
//# sourceMappingURL=markItemsJunkNotJunkFromTable.js.map